import {
  ApiBlueprint,
  configApiRef,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  launchDarklyApiRef,
  LaunchDarklyRestApi,
} from '@internal/backstage-plugin-neo4j-launch-darkly-react';

// ── API (→ global API registry) ─────────────────────────
const launchDarklyApi = ApiBlueprint.make({
  name: 'launch-darkly-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: launchDarklyApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          config: configApiRef,
        },
        factory: ({ discoveryApi, fetchApi, config }) =>
          new LaunchDarklyRestApi({ discoveryApi, fetchApi, config }),
      }),
    ),
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-launch-darkly',
  extensions: [launchDarklyApi],
});
